module.exports = __webpack_public_path__ + "src/assets/animations/worker.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/worker.txt
// module id = ./src/assets/animations/worker.txt
// module chunks = 0